import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ListGroupItem from "react-bootstrap/ListGroupItem";
import ListGroup from "react-bootstrap/ListGroup";
import NbioApi from "../../../lib/api/NbioApi";
import {money} from "../../../lib/money/money";
import _ from "underscore";
import Row from "react-bootstrap/cjs/Row";
import Col from "react-bootstrap/Col";
import {Alert, Placeholder, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {toast} from "sonner";
import DropdownButton from "react-bootstrap/DropdownButton";
import {parcels} from "../../../lib/parcels/parcels";
import DropdownItem from "react-bootstrap/DropdownItem";

const STATES = [
    "Aguascalientes",
    "Baja California",
    "Baja California Sur",
    "Campeche",
    "Chiapas",
    "Chihuahua",
    "Ciudad de México",
    "Coahuila",
    "Colima",
    "Durango",
    "Guanajuato",
    "Guerrero",
    "Hidalgo",
    "Jalisco",
    "México",
    "Michoacán",
    "Morelos",
    "Nayarit",
    "Nuevo León",
    "Oaxaca",
    "Puebla",
    "Querétaro",
    "Quintana Roo",
    "San Luis Potosí",
    "Sinaloa",
    "Sonora",
    "Tabasco",
    "Tamaulipas",
    "Tlaxcala",
    "Veracruz",
    "Yucatán",
    "Zacatecas"
]
const QuoteModal = (
    {
        show = false,
        orderId = '',
        onClose = () => {}
    }
) => {
    const [step,setStep] = useState('select');
    const [rates, setRates] = useState([]);
    const [loading,setLoading] = useState(false);
    const [selectedRateIndex,setSelectedRateIndex] = useState(-1);
    const [isLoadingRates,setIsLoadingRates] = useState(false);
    const [order,setOrder] = useState({});
    const [name,setName] = useState("");
    const [company,setCompany] = useState("");
    const [email,setEmail] = useState("");
    const [street,setStreet] = useState("");
    const [streetNumber,setStreetNumber] = useState("");
    const [zipCode,setZipCode] = useState("");
    const [borough,setBorough] = useState("");
    const [locality,setLocality] = useState("");
    const [rfc,setRfc] = useState("");
    const [reference,setReference] = useState("");
    const [state,setState] = useState("");
    const [phone,setPhone] = useState("");
    const [selectedShippingOption,setSelectedShippingOption] = useState("envia");
    const [isAddingParcel,setIsAddingParcel] = useState(false);
    const [parcelNumber,setParcelNumber] = useState('');
    const [parcelName, setParcelName] = useState('');
    useEffect(() => {
        getQuotes();
        getOrder();
    }, []);
    const getOrder = ()=>{
        NbioApi.orders.getOrder(orderId).then((res) =>{
            const order = res.data.order;
            setName(`${res.data.order.shipping.name} ${res.data.order.shipping.lastName}`)
            setEmail(res.data.order.client.email || res.data.order.user.email || '');
            setOrder(res.data.order);
            setStreet(order?.shipping.address);
            setBorough(order?.shipping.borough);
            setZipCode(order?.shipping.zipCode);
            setLocality(order?.shipping.locality || '');
            setPhone(order?.shipping.phone);
            setState(order?.shipping.state);
            setRfc(order?.invoiceData?.rfc || '');
            setReference(order?.shipping?.reference|| '');
        }).catch((ex) =>{

        })
    }
    const closeModal = () =>{
        setRates([]);
        setIsLoadingRates(false);
        setSelectedRateIndex(-1);
        setSelectedShippingOption('envia');
        setStep('select');
        onClose();
    }
    const getCarrierIcon = (carrier) =>{
        if(carrier === 'dhl'){
            return <div
                style={
                    {
                        display: "flex",
                        height:30,
                        width:30,
                        backgroundImage:`url(https://s3.us-east-2.amazonaws.com/enviapaqueteria/uploads/logos/carriers/dhl.svg)`,
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                    }
            }>
            </div>
        }else if(carrier === 'paquetexpress'){
            return <div
                style={
                    {
                        display: "flex",
                        height:30,
                        width:30,
                        backgroundImage:`url(https://s3.us-east-2.amazonaws.com/enviapaqueteria/uploads/logos/carriers/paquetexpress.svg)`,
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                    }
                }>
            </div>

        }else if(carrier === 'dhl'){
            return <div
                style={
                    {
                        display: "flex",
                        height:30,
                        width:30,
                        backgroundImage:`url(https://s3.us-east-2.amazonaws.com/enviapaqueteria/uploads/logos/carriers/dhl.svg)`,
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                    }
                }>
            </div>
        }else if(carrier === 'fedex'){
            return <div
                style={
                    {
                        display: "flex",
                        height:30,
                        width:30,
                        backgroundImage:`url(https://s3.us-east-2.amazonaws.com/enviapaqueteria/uploads/logos/carriers/fedex.svg)`,
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                    }
                }>
            </div>
        }
    }
    const getQuotes = () =>{
        setIsLoadingRates(true);
        NbioApi.orders.shippingRates(orderId).then((response) => {
            setRates(_.sortBy(response.data.rates,(r) => r.totalPrice));
        }).catch((error) => {

        }).finally(() =>{
            setIsLoadingRates(false);
        })
    }
    const onChange = () =>{

    }
    const isAddressValid = () =>{
        if (name.trim() === '') {
            return {
                isValid: false,
                message: 'El nombre no puede estar vacío'
            }
        }
        if (phone.trim() === '') {
            return {
                isValid: false,
                message: 'El número telefónico no puede estar vacío'
            }
        }
        if (email.trim() === '') {
            return {
                isValid: false,
                message: 'El e-mail no puede estar vacío'
            }
        }
        if (street.trim() === '') {
            return {
                isValid: false,
                message: 'La calle no puede estar vacía'
            }
        }
        if (borough.trim() === '') {
            return {
                isValid: false,
                message: 'La delegación no puede estar vacía'
            }
        }
        if (zipCode.trim() === '') {
            return {
                isValid: false,
                message: 'La código postal no puede estar vacío'
            }
        }
        if (locality.trim() === '') {
            return {
                isValid: false,
                message: 'La ciudad no puede estar vacía'
            }
        }
        if (state.trim() === '') {
            return {
                isValid: false,
                message: 'El estado no puede estar vacío'
            }
        }
        return {
            isValid: true,
            message: ''
        }
    }
    const renderSelect = () =>{
        return <div>
            <Alert> Selecciona una opción </Alert>
            <Form.Group as={Row} className="mb-3" controlId="option">
                <Form.Label column sm={2}>Tipo de envío</Form.Label>
                <Col sm={10}>
                    <Form.Check
                        type={'radio'}
                        id={`check-option-envia`}
                        checked={selectedShippingOption === 'envia'}
                        onClick={() => setSelectedShippingOption('envia')}
                        label={"Cotizar con envia.com"}
                    />
                    <Form.Check
                        type={'radio'}
                        id={`check-option-manual`}
                        onClick={() => setSelectedShippingOption('manual')}
                        checked={selectedShippingOption === 'manual'}
                        label={"Ingresar datos manualmente"}
                    />
                </Col>
            </Form.Group>
        </div>
    }
    const renderAddress = () =>{
        return <div>
            <Alert> Valida la dirección de entrega: </Alert>
            <h5>Contacto</h5>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="email">
                <Form.Label column sm={2}>Email</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Email"
                                  value={email}
                                  onChange={event => setEmail(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="name">
                <Form.Label column sm={2}>Nombre completo</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Nombre completo"
                                  value={name}
                                  onChange={event => setName(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="phone">
                <Form.Label column sm={2}>Teléfono</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Teléfono"
                                  value={phone}
                                  onChange={event => setPhone(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="business">
                <Form.Label column sm={2}>Empresa</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Empresa"
                                  value={company}
                                  onChange={event => setCompany(event.target.value)}/>
                </Col>
            </Form.Group>
            <h5>Dirección de envío</h5>

            <Form.Group as={Row} className="mb-3 ml-1" controlId="street">
                <Form.Label column sm={2}>Calle</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Calle"
                                  value={street}
                                  onChange={event => setStreet(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="number">
                <Form.Label column sm={2}>Número</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Número"
                                  value={streetNumber}
                                  onChange={event => setStreetNumber(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="locality">
                <Form.Label column sm={2}>Ciudad</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Ciudad"
                                  value={locality}
                                  onChange={event => setLocality(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="colonia">
                <Form.Label column sm={2}>Delegación o Colonia</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Delegación o Colonia"
                                  value={borough}
                                  onChange={event => setBorough(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="zipCode">
                <Form.Label column sm={2}>Código Postal</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Código Postal"
                                  value={zipCode}
                                  onChange={event => setZipCode(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="reference">
                <Form.Label column sm={2}>Estado</Form.Label>
                <Col sm={10}>
                    <Form.Select  id="state"
                                  value={state}
                                  placeholder="00"
                                  onChange={(event) => setState(event.target.value)}>
                        {
                            STATES.map((state, index) => {
                                return (
                                    <option value={state} key={index}>{state}</option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 ml-1" controlId="reference">
                <Form.Label column sm={2}>Referencia</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="Referencia"
                                  value={reference}
                                  onChange={event => setReference(event.target.value)}/>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3 ml-1" controlId="rfc">
                <Form.Label column sm={2}>RFC</Form.Label>
                <Col sm={10}>
                    <Form.Control type="text"
                                  placeholder="RFC"
                                  value={rfc}
                                  onChange={event => setRfc(event.target.value)}/>
                </Col>
            </Form.Group>



        </div>
    }
    const renderStep = () =>{
        if(step === 'select'){
            return renderSelect();
        }
        if(step === 'address') {
            return renderAddress();
        }
        if(step === 'rates'){
            return renderQuotes();
        }
        if(step === 'manual'){
            return renderManual();
        }
    }
    const renderManual = () =>{
        return <Form>
            <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column sm="2">
                    Número de guía
                </Form.Label>
                <Col sm="10">
                             <Form.Control type="text"
                                           placeholder="Número de guía"
                                           value={parcelNumber}
                                           onChange={event => setParcelNumber(event.target.value)}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                <Form.Label column sm="2">
                    Paquetería
                </Form.Label>
                <Col sm="10">
                    <DropdownButton id="dropdown-basic-button" title={parcelName|| 'Paquetería'} variant={'primary'}>
                                    {
                                         parcels.map((parcel,index) =>{
                                             return <DropdownItem key={index} onClick={() => setParcelName(parcel.name)}>
                                                 {parcel.name}
                                             </DropdownItem>
                                         })
                                     }

                                 </DropdownButton>
                </Col>
            </Form.Group>
        </Form>
        // return <Form.Group  className="mb-3" controlId="option">
        //     <Col sm="10">
        //

        //     </Col>
        // </Form.Group>
    }
    const goToStart = () =>{
        setStep('select');
        setSelectedRateIndex(-1);
        setRates([]);
        setIsAddingParcel(false);
    }
    const goToAddressOrManual = () => {
        setStep(selectedShippingOption === 'envia'? 'address' :'manual');
    }
    const goToAddress = () => {
        setStep('address');
        setSelectedRateIndex(-1);
        setRates([]);
    }
    const goToShipping = () =>{
        if(selectedShippingOption === 'envia'){
            setStep('shipping');
        } else{
            setStep('shipping_manual');
        }
    }
    const goToRates = () =>{
        const {isValid,message} = isAddressValid();
        if(!isValid){
            toast.error(message);
        }else{
            getQuotes();
            setStep('rates');
        }
    }
    const createShipping = async () =>{
        setIsAddingParcel(true);
        if(selectedRateIndex < 0){
            toast.error("Selecciona un envío para crear la guía correspondiente");
            setIsAddingParcel(false);
            return -1;
        }
        const destination = {
            "name": name,
            "company": company,
            "email": email,
            "phone": phone,
            "street": street,
            "number": streetNumber,
            "district": borough,
            "city": locality,
            "state": state,
            "country": "MX",
            "postalCode": zipCode,
            "reference": reference
        };
        const shipment = {
            "carrier": rates[selectedRateIndex].carrier,
            "service": rates[selectedRateIndex].service,
            "type":1
        };
        try{
            const createShippingRes = await NbioApi.orders.createShipping(orderId,destination,shipment);
            toast.error("Guía creada");
            closeModal();
        }catch(ex){
            // TODO: Error
            toast.error("Hubo un problema al crear la guía.");

        }finally {
            setIsAddingParcel(false);
        }

    }
    const renderFooter = () =>{
        if(step === 'select'){
            return <>
                    <Button variant="primary" onClick={() => goToAddressOrManual()}>Siguiente</Button>
            </>
        }
        if(step === 'address') {
            return <>
                <Button variant="secondary" onClick={() => goToStart()}>Anterior</Button>
                <Button variant="primary" onClick={() => goToRates()}>Siguiente</Button>
            </>
        }
        if(step === 'rates'){
            return <>
                <Button variant="secondary" onClick={() => goToAddress()}>Anterior</Button>
                {
                    isAddingParcel ?
                        <Spinner animation={'border'} color={'primary'}></Spinner> :
                        <Button variant="primary" onClick={() => createShipping()}>Crear guía</Button>
                }
            </>
        }
        if(step === 'manual') {
            return <>
                <Button variant="secondary" onClick={() => {goToStart()}}>Anterior</Button>
                {
                    isAddingParcel ?
                        <Spinner animation={'border'} color={'primary'}></Spinner> :
                        <Button variant={'primary'} onClick={() =>{addParcel()}}
                                disabled={!parcelNumber.trim() || !parcelName.trim()}>
                            Agregar guía
                        </Button>
                }
            </>
        }
    }
    const addParcel = () =>{
        setIsAddingParcel(true);
        const parcelTrackingLink = parcels.find((p) => p.name === parcelName)
            .generateTrackingUrl(parcelNumber);
        NbioApi.orders.addParcel(
            orderId,
            parcelName,
            parcelNumber,
            parcelTrackingLink
        ).then((res) =>{
            setParcelNumber('');
            setParcelName('');
            closeModal();
        }).catch((ex) =>{

        }).finally(() =>{
           setIsAddingParcel(false);
        });
    }
    const renderQuotes = () =>{
        return <div>
            <Alert> Selecciona un envío: </Alert>
            {
                isLoadingRates ?
                    <ListGroup>
                        <ListGroupItem>
                            <Placeholder as="p"  animation={'glow'}>
                                <Placeholder xs={12} bg="light" />
                            </Placeholder>
                        </ListGroupItem>
                        <ListGroupItem>
                            <Placeholder as="p"  animation={'glow'}>
                                <Placeholder xs={12} bg="light" />
                            </Placeholder>
                        </ListGroupItem>
                        <ListGroupItem>
                            <Placeholder as="p"  animation={'glow'}>
                                <Placeholder xs={12} bg="light" />
                            </Placeholder>
                        </ListGroupItem>
                        <ListGroupItem>
                            <Placeholder as="p"  animation={'glow'}>
                                <Placeholder xs={12} bg="light" />
                            </Placeholder>
                        </ListGroupItem>
                    </ListGroup> :
                    <ListGroup>
                        {
                            rates.map((rate, index)  => {
                                return <ListGroupItem style={{display:"flex", justifyContent:"space-between",cursor:"pointer"}} onClick={() =>{
                                    setSelectedRateIndex(index);
                                }}>
                                    <div className={'d-flex'}>
                                        &nbsp;
                                        &nbsp;
                                        <Form.Check
                                            type={'radio'}
                                            id={`check-rate-${index}`}
                                            checked={selectedRateIndex === index}
                                        />
                                        &nbsp;
                                        {getCarrierIcon(rate.carrier)} &nbsp;{rate.serviceDescription}
                                    </div>
                                    <div className={'d-flex'}>
                                        {rate.deliveryDate.date}&nbsp;<b>{money(rate.totalPrice)}</b>
                                    </div>

                                </ListGroupItem>
                            })
                        }
                    </ListGroup>
            }



        </div>
    }
    return (<Modal fullscreen={true} show={show}>
            <Modal.Header closeButton onHide={ () => closeModal()}>
                <Modal.Title>Cotizador</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderStep()}
                <Modal.Footer>
                    {renderFooter()}
                </Modal.Footer>
            </Modal.Body>
    </Modal>)
}
export default QuoteModal;